import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Deletepopup from "../../components/common/Aresure";
import Loader from "../../Loader/Loader";
import { Pencil, Plus, Trash } from "lucide-react";
import { Snackbar } from "../../utils/snackbar";
import { deletesubcategory, subcategory } from "../../services/Mainservice";
import Pagination from "../../components/common/pagination";

const SubcategoryList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();
  const handleClose = (event, reason) => {
    setOpen(false);
  };

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async (page) => {
    try {
      const response = await subcategory(page);
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  // const handlesearch = async (e) => {
  //   setsearchvalue(e.target.value);
  //   getData(1, e.target.value);
  // };

  const handledelete = async () => {
    console.log("click");
    try {
      const response = await deletesubcategory(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Subcategory List</h1>
          <div className="data_headdown">
            <h1
              className="data_add"
              onClick={() => navigate("/Add_Subcategory")}
            >
              <Plus /> Add Subcategory
            </h1>

            {/* <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                // onKeyDown={handlesearch}
              />
            </div>*/}
          </div>
        </div>
        {data ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Subcategory Name</th>
                    <th>Image</th>

                    <th>Category Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.Name}</td>
                        <td>
                          <img
                            src={item.image}
                            alt="category"
                            className="categoryimg"
                          />
                        </td>
                        <td>{item.categoryName}</td>

                        <td>
                          {/* <button
                      // onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button> */}
                          <div className="user_actionicon">
                            {" "}
                            <Pencil
                              sx={{ color: "var(--red)" }}
                              onClick={() =>
                                navigate("/Edit_Subcategory", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <Trash
                              sx={{ color: "var(--red)" }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <Pagination pagedata={pagination} onPageChange={getData} />
            </div>
          </>
        ) : (
          <p className="nodata">No Subcategory</p>
        )}

        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handleDelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={err}
      />
    </>
  );
};
export default SubcategoryList;
